module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.13686/images/use_case_content.svg"